<template>
    <div>

        <MiddleArea></MiddleArea>

        <BottomArea></BottomArea>

    </div>
</template>


<script>
   // import moment from 'moment'
    import MiddleArea from './MiddleArea.vue';
    import BottomArea from './BottomArea.vue';

    export default {
        components: {
            MiddleArea,
            BottomArea
        },
        data: function () {
            return {
            }
        },
        mounted: function () {
        },
        methods: {
        },
        filters:{
        }
    };
</script>
